export const CONFIG = {
  // Número do SDR, em formato internacional completo, só dígitos: 55 + DDD 85
  // + 994086359. O código não concatena nada, para não gerar wa.me/5555...
  whatsapp: '5585994086359',

  // Webhook do n8n que já roda no VPS. Vazio desliga a telemetria, e a
  // página funciona igual.
  webhookEventos: '',

  dados: 'dados/empreendimentos.geojson',
  detalhe: (slug) => `dados/detalhe/${slug}.json`,

  // Tudo servido pelo próprio nginx. Nenhuma chamada a domínio de terceiro:
  // foi uma dependência assim que cobriu o mapa anterior de marca d'água.
  basemap: 'assets/ceara.pmtiles',
  glifos: 'assets/fontes/{fontstack}/{range}.pbf',
  sprites: 'assets/sprites/v4/light',

  // Enquadramento inicial: Região Metropolitana de Fortaleza
  centro: [-38.53, -3.78],
  zoom: 10.5,
  limitesCeara: [[-41.5, -8.0], [-37.0, -2.7]],

  // Três faixas sem sobreposição. As cápsulas entram depois dos pinos porque
  // ocupam cerca de 90 px de largura contra 26 px de um pino.
  zoomMaxAgrupamento: 14,   // até aqui, só grupos
  zoomCapsulas: 16,         // daqui em diante, cápsulas de preço

  cor: {
    marca: '#e72560',
    // Os grupos do mapa levam a contagem em branco por cima: é texto, então
    // usa a variante que passa em contraste. Ver --marca-texto no CSS.
    marcaTexto: '#e2245e',
    apartamento: '#3b82f6',
    casa: '#10b981',
    loteamento: '#f59e0b',
    praia: '#06b6d4',
    empresarial: '#8b5cf6',
    outro: '#64748b',
  },

  rotuloTipo: {
    apartamento: 'Apartamento',
    casa: 'Casa',
    loteamento: 'Loteamento',
    praia: 'Praia',
    empresarial: 'Empresarial',
  },
};
